import Button from "@mui/material/Button"
import {
  Elements,
  PaymentElement,
  useElements,
  useStripe,
} from "@stripe/react-stripe-js"
import { loadStripe } from "@stripe/stripe-js"
import { useEffect, useState } from "react"

import { useAuthorizedAxiosClient } from "../../../common/axios"
import CloseableSnackbar from "../../../common/components/CloseableSnackbar"

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY, {
  developerTools: { assistant: { enabled: false } },
})

export default function StripeElementsForm({ onIsLoadingChanged }) {
  const [stripeClientSecret, setStripeClientSecret] = useState()
  const DEFAULT_SNACKBAR_DATA = { open: false, message: "" }
  const [snackbarData, setSnackbarData] = useState(DEFAULT_SNACKBAR_DATA)

  const axios = useAuthorizedAxiosClient()

  const stripeOptions = {
    clientSecret: stripeClientSecret,
  }

  useEffect(
    () => {
      onIsLoadingChanged(true)
      axios
        .get("/billing/api/stripe-client-secret/")
        .then(({ data }) => {
          setStripeClientSecret(data.client_secret)
        })
        .finally(() => onIsLoadingChanged(false))
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  )

  if (!stripeClientSecret) {
    return null
  }

  return (
    <Elements stripe={stripePromise} options={stripeOptions}>
      <StripeForm />
      <CloseableSnackbar
        open={snackbarData.open}
        message={snackbarData.message}
        onClose={() => setSnackbarData(DEFAULT_SNACKBAR_DATA)}
      />
    </Elements>
  )
}

function StripeForm() {
  const stripe = useStripe()
  const elements = useElements()

  async function handleSavePaymentMethodButtonClicked() {
    if (!stripe || !elements) {
      return
    }
    await stripe.confirmSetup({
      elements,
      confirmParams: {
        return_url: `${window.location.origin}/settings/`,
      },
    })
  }

  return (
    <>
      <PaymentElement />
      <Button
        variant="contained"
        disabled={!stripe}
        onClick={handleSavePaymentMethodButtonClicked}
        sx={{ mt: 2 }}
      >
        Add payment method
      </Button>
    </>
  )
}
